module.exports = __webpack_public_path__ + "static/media/Alignment.2f3df8d6.svg";